import { Injectable } from "@angular/core";
import { MockupHttpInterceptor } from "@vattenfall/core";

import { CampaignProductCardFinland } from "./campaign-product-card-finland.model";

export const data: CampaignProductCardFinland[] = [
  {
    productId: "1",
    agreementName: "Ilmasto Mix 24 kk",
    monthlyBaseFee: { value: 3.8, unit: "EURO/MONTH" },
    discountedMonthlyBaseFee: { value: 2.6, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 12, unit: "MONTH" },
    productType: "fixed",
    hideMonthlyCost: false,
    energySourceName: "Tuulivoima",
    originFee: { value: 1.24, unit: "EURO/MONTH" },
  },
  {
    productId: "2",
    agreementName: "Fixed price",
    monthlyBaseFee: { value: 3.8, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    productType: "fixed",
    hideMonthlyCost: false,
    energySourceName: "Aurinko alkuperä",
    originFee: { value: 1.0, unit: "EURO/MONTH" },
  },
  {
    productId: "3",
    agreementName: "Optimi Pörssisähko + hinnankiinnitysturva",
    monthlyBaseFee: { value: 5.95, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5, unit: "EURO_CENT/KWH" },
    spotGuardFee: { value: 4.9, unit: "EURO/MONTH" },
    contractLength: { value: 24, unit: "MONTH" },
    productType: "spot",
    hideMonthlyCost: true,
  },
];

@Injectable()
export class CampaignProductCardFinlandServiceMockup extends MockupHttpInterceptor<CampaignProductCardFinland> {
  constructor() {
    super({
      pathMatcher: "/api/acquisition/products/:productId",
      delay: 500,
      data,
    });
  }
}
